/* Trigger card — "Choose your layout" mode entry point (PDP). Flyout title color: `panelShell.headerTitle` in panel-shell.js. */

/** Shared typography for section headers (color is per-part — avoid two `useMultiStyleConfig` parts on one `Text`; merged props can drop `color`). */
const SECTION_HEADER_SHARED = {
  fontFamily: 'body',
  fontSize: {base: 'md', lg: 'lg'},
  fontStyle: 'normal',
  fontVariantNumeric: 'lining-nums proportional-nums',
  fontWeight: 500,
  lineHeight: {base: 1.4, lg: 1.2},
  marginBottom: 4,
};

export const triggerCardParts = [
  'sectionHeader',
  'sectionHeaderChooseYourLayout',
  'triggerCard',
  'triggerImageWrapper',
  'triggerImage',
  'triggerContent',
  'triggerTitle',
  'triggerDescription',
  'triggerChangeLabel'
];

export const triggerCardBaseStyle = {
  sectionHeader: {
    ...SECTION_HEADER_SHARED,
    color: {base: 'brandColors.greyscale90', lg: 'brandColors.greyscale90'},
  },
  sectionHeaderChooseYourLayout: {
    ...SECTION_HEADER_SHARED,
    color: {base: 'brandColors.greyscale90', lg: 'brandColors.greyscale90'},
  },
  triggerCard: {
    alignSelf: 'stretch',
    alignItems: 'center',
    bg: 'white',
    border: '1px solid',
    borderColor: 'white',
    borderRadius: '6px',
    display: 'flex',
    gap: 4,
    padding: '16px 20px 16px 16px',
    transition: 'all 0.2s ease',
    width: '100%',
    _hover: {
      borderColor: 'grayAlpha.90',
      bg: 'white',
    },
    _focus: {
      boxShadow: 'outline',
      outline: 'none',
    },
  },
  triggerImageWrapper: {
    flexShrink: 0,
    width: 12.5,
    aspectRatio: '1',
    overflow: 'hidden',
    bg: 'transparent',
  },
  triggerImage: {
    height: '100%',
    objectFit: 'contain',
    width: '100%',
  },
  triggerContent: {
    flex: 1,
    minWidth: 0,
  },
  triggerTitle: {
    color: {base: 'brandColors.greyscale90', lg: 'brandColors.greyscale90'},
    fontFamily: 'body',
    fontSize: {base: 'sm', lg: 'md'},
    fontStyle: 'normal',
    fontVariantNumeric: 'lining-nums proportional-nums',
    fontWeight: 600,
    lineHeight: 1.4,
  },
  triggerDescription: {
    color: {base: 'brandColors.greyscale70', lg: 'brandColors.greyscale90'},
    fontFamily: 'body',
    fontSize: {base: '1xs', lg: 'xs'},
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 1.2,
    marginTop: 1,
    textAlign: 'left',
  },
  triggerChangeLabel: {
    color: 'brandColors.primaryDarkLinen',
    flexShrink: 0,
    fontFamily: 'body',
    fontSize: {base: '1xs', lg: 'xs'},
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 1.2,
    textAlign: 'right',
  },
};
